import { Container, IconButton, TextField } from "@mui/material";
import { t } from "i18next";
import { Box , Stack} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import GuidSectionsAccardion from "../../components/atomic/guid-sections-accardion"
import BreadCrumbGuidSections from "../../components/breadcrumbguidsections";
import { useEffect } from "react";

const GuidSections = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = '   راهنما'
    }, [])
    return (
        <>
            <Box sx={{ bgcolor: 'background.default', textAlign: 'center', py: 4, position: 'relative' }}>
                <Container >

                    <Stack direction={{xs:'column' , sm:'row'}} justifyContent={'space-between'} alignItems={{xs:'start' , sm:'center'}}>
                        
                        <BreadCrumbGuidSections />
                        
                            <TextField
                                className="search-input-faq"
                                sx={{ width: { md: '35%', xs: '90%' }, color: '#fff' }}
                                placeholder={`${t('search_your_question')}`}
                                InputProps={{
                                    style: {
                                        padding: '.1rem 1.5rem',
                                        borderRadius: '50px',
                                        background: '#181541',
                                        border: 'none',
                                        color: '#fff'
                                    },
                                    endAdornment: (
                                        <IconButton sx={{}}>
                                            <SearchIcon fontSize="large" />
                                        </IconButton>
                                    ),

                                }}
                            />
                        
                    </Stack>
                </Container>
            </Box>


            <GuidSectionsAccardion />
        </>
    )
}

export default GuidSections